/** How early before startDate the SOON badge should appear (milliseconds) */
export const ACTIVITY_SOON_THRESHOLD_MS = 5 * 60 * 1000 // 5 minutes

/** Fallback tick interval for re-evaluating time-based status (milliseconds) */
export const ACTIVITY_STATUS_TICK_INTERVAL_MS = 30 * 1000 // 30 seconds

/**
 * Keys for the React Query cache entries that must be invalidated
 * when a Firestore session document changes.
 */
export const GAMER_ACTIVITY_QUERY_KEYS = ['upcoming-activities-gamer', 'upcoming-activities-gamer-list'] as const

export const FACILITATOR_ACTIVITY_QUERY_KEYS = [
  'upcoming-activities',
  'facilitatorDashboard',
  'facilitatorLiveSessionMonitor'
] as const
